import React from 'react'
import styled from 'styled-components'

import { useMedia } from '@/utils/use-media'
import code from '@/assets/images/code-snippet@1x.png'
import code2x from '@/assets/images/code-snippet@2x.png'
import { AndroidLogo, IosLogo, ReactNativeSDKIcon, WebSDKLogo } from '@/components/ui/icons'
import { mobile } from '@/utils/media-query'
import { GradientLink } from '@/components/ui/gradient-link'
import { useIsMounted } from '@/utils/use-is-mounted'

import { SectionBlock } from './section'

const Info = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${mobile.query} {
    flex-direction: column;
    align-items: flex-start;
  }
`

const Graphic = styled.img`
  margin-right: 40px;
  display: block;
  max-width: 755px;
  object-fit: contain;
  width: 100%;

  @media ${mobile.query} {
    margin: 0;
    width: 540px;
  }
`

const MobileDocs = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 340px;
  min-width: 200px;
  justify-content: center;
  flex: 1;

  @media ${mobile.query} {
    margin-top: 75px;
    width: 100%;
  }
`

const Title = styled.h3`
  opacity: 1;
  margin: 0 0 15px;
`

const Links = styled.div`
  display: flex;
  flex-direction: column;
`

const Link = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  a {
    margin-left: 10px;
  }
`

const Label = styled.span`
  align-items: center;
  background: ${({ theme }) =>
    `linear-gradient(45deg, #9345fa 0%, ${theme.palette.giphyRed} 100%)`};
  border-radius: 7px;
  color: ${({ theme }) => theme.palette.giphyBlack};
  display: inline-flex;
  font-family: InterFace-XBold;
  font-size: 9px;
  font-weight: bold;
  justify-content: center;
  padding: 3px 4px;
  margin: 5px;
`

const CodeExampleContainer = styled.div`
  margin-right: 18px;

  @media ${mobile.query} {
    margin: 0;
    max-width: 100vw;
    overflow: hidden;
  }
`

const CodeExample = () => {
  const isMobileScreen = useMedia(mobile.query, false)
  const isMounted = useIsMounted()
  return isMounted ? <Graphic src={isMobileScreen ? code : code2x} /> : null
}

export const SdkExamplesBlock = () => {
  const isMobileScreen = useMedia(mobile.query, false)
  const isMounted = useIsMounted()

  return (
    <SectionBlock>
      {isMobileScreen
        ? isMounted && (
            <>
              <CodeExampleContainer>
                <CodeExample />
              </CodeExampleContainer>
              <Info>
                <MobileDocs>
                  <Title>iOS, Android, & Web Support</Title>
                  <p>
                    Whether you’re building for iOS or Android, or Web, we’ve got you covered. The
                    GIPHY SDK works cross platform with sample code and example apps to make
                    implementation fast and easy.
                  </p>
                  <Links>
                    <Link>
                      <ReactNativeSDKIcon />
                      <GradientLink text="Open React Docs" url="/docs/sdk#react-native" />
                      <Label>NEW</Label>
                    </Link>
                    <Link>
                      <IosLogo />
                      <GradientLink text="Open iOS Docs" url="/docs/sdk#ios" />
                    </Link>
                    <Link>
                      <AndroidLogo />
                      <GradientLink text="Open Android Docs" url="/docs/sdk#android" />
                    </Link>
                    <Link>
                      <WebSDKLogo />
                      <GradientLink text="Open Web Docs" url="/docs/sdk#web" />
                    </Link>
                  </Links>
                </MobileDocs>
              </Info>
            </>
          )
        : isMounted && (
            <Info>
              <CodeExampleContainer>
                <CodeExample />
              </CodeExampleContainer>
              <MobileDocs>
                <Title>iOS, Android, & Web Support</Title>
                <p>
                  Whether you’re building for iOS, Android, or Web, we’ve got you covered. GIPHY SDK
                  works cross platform with sample code and example apps to make implementation fast
                  and easy.
                </p>
                <Links>
                  <Link>
                    <ReactNativeSDKIcon />
                    <GradientLink text="Open React Docs" url="/docs/sdk#react-native" />
                    <Label>NEW</Label>
                  </Link>
                  <Link>
                    <IosLogo />
                    <GradientLink text="Open iOS Docs" url="/docs/sdk#ios" />
                  </Link>
                  <Link>
                    <AndroidLogo />
                    <GradientLink text="Open Android Docs" url="/docs/sdk#android" />
                  </Link>
                  <Link>
                    <WebSDKLogo />
                    <GradientLink text="Open Web Docs" url="/docs/sdk#web" />
                  </Link>
                </Links>
              </MobileDocs>
            </Info>
          )}
    </SectionBlock>
  )
}
